'use strict';

var dialog = require('../../dialog'),
	util = require('../../util'),
	ajax = require('../../ajax'),
	linchpin = require('int_googletagmanager/linchpin/product'),
	addToCart = require('./addToCart'),
	quantity = require('./quantity'),
	progress = require('../../progress');

/**
 * @description Updates product details section
 */
function refreshContent(href) {
	var $pdpForm = $('.pdpForm'),
		params = {
			Quantity: '1',
			source: 'pdp',
			productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
		};

	progress.show($('#pdpMain'));

	ajax.load({
		url: util.appendParamsToUrl(href, params),
		target: $('#product-detail-wrapper'),
		callback: function () {
			$(window).trigger('productChanged');
			$(document).trigger('productVariationChanged');
		}
	});
}

/**
 * @description Handler to handle the agree and reserve all specials event
 */
function callSpecialClubReservation() {
	var options = {
		url: util.ajaxUrl(Urls.specialClubReservation),
		method: 'POST',
		data: {selectedType: $('.variation-select').find('option:selected').data('type')}
	};
	$.ajax(options).done(function (response) {
		if (response.status === 'success') {
			refreshContent($('.variation-select').val());
		} else {
			var $errorMsg = $('.service-error-message');
			var error = $errorMsg.find('span.error');
			if (error.length === 0) {
				error = $('<span>').addClass('error').appendTo($errorMsg);
			}
			error.html(Resources.CALL_CUSTOMER_SERVICE);
		}
	});
}

/**
 * @function
 * @description Binds the events on the reminders form (edit, create, delete)
 */
function initSpecialClubEvents() {
	var specialclub = $('.specialsclub');
	if (specialclub.length === 0) { return; }

	$('.reserve-all-specials').on('click', function (e) {
		e.preventDefault();
		dialog.open({
			url: Urls.reserveAllSpecialsConfirm,
			options: {
				buttons: [
					{
						text: Resources.CANCEL,
						'class':'button-gray cancel',
						click: function () {
							dialog.close();
						}
					},
					{
						text: Resources.AGREE_AND_RESERVE,
						'class':'reserve',
						click: function () {
							callSpecialClubReservation();
							dialog.close();
						}
					}
				],
				dialogClass: 'reserve-all-specials-dialog',
				title: Resources.TERMS_AND_CONDITIONS
			},
			allowMultipleDialogs: true
		});
	});

	/**
	 * @private
	 * @function
	 * @description Enables submit button on Voucher Form
	 */
	function initApplyBtnValidation() {
		var $applyBtn = $('.reserve-special-dialog .apply');
		$applyBtn.prop('disabled', true);
		$('#voucher-form :input').blur();
		$('#voucher-form :input').keyup('input', function () {
			if ($(this).val() !== '') {
				$applyBtn.prop('disabled', false);
			} else {
				$applyBtn.prop('disabled', true);
			}
		});
	}

	$('#pdpMain').on('click', '.reserve-now-specials', function (e) {
		e.preventDefault();
		var url = util.appendParamsToUrl(Urls.reserveSpecial, {pid: $('#pid').val()});
		dialog.open({
			url: url,
			options: {
				dialogClass: 'reserve-special-dialog',
				title: Resources.RESERVE_NOW,
				open: function () {
					initApplyBtnValidation();
					$('.reserve-special-dialog').on('click', '[name$=_reserveNow]', function (e) {
						e.preventDefault();
						dialog.submit($(this).attr('name'), function () {
							var url = util.appendParamsToUrl(Urls.loadSpecialActions, {pid: $('#pid').val()});
							ajax.load({
								url: url,
								target: $('#reserve-special-action'),
								callback: function () {
									addToCart();
									quantity.init();
									// GTM Linchpin analytics
									if (SitePreferences.GTM_ENABLED) {
										var isQuickView = $('.ui-dialog.quickview-dialog:visible').length > 0;
										if (isQuickView) {
											linchpin.triggerQuickViewReserveEvent();
										} else {
											linchpin.triggerReserveNowEvent();
										}
									}
								}
							});
							dialog.close();
						});
					});
					$('.reserve-special-dialog').on('click', '[name$=_applyVoucher]', function (e) {
						e.preventDefault();
						dialog.submit($(this).attr('name'), function () {
							// GTM Linchpin analytics
							if (SitePreferences.GTM_ENABLED) {
								linchpin.triggerAddVoucherEvent();
							}
						});
					});
					$('.reserve-special-dialog').on('click', '[name$=_cancel]', function (e) {
						e.preventDefault();
						dialog.close();
					});
				},
				close: function () {
					$('.reserve-special-dialog').off('click', '[name$=_reserveNow]');
					$('.reserve-special-dialog').off('click', '[name$=_applyVoucher]');
					$('.reserve-special-dialog').off('click', '[name$=_cancel]');
				}
			},
			allowMultipleDialogs: true
		});
	});
}

exports.init = function () {
	initSpecialClubEvents();
};
